import React, {useCallback, useEffect, useMemo, useRef} from 'react'
import WizDropdown from '@component/dropdowns/WizDropdown'
import WizIcon from '@component/images/WizIcon'
import IconEdit from '@svg/common/ic_edit.svg'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import {useTranslation} from '@lib/intl/useTranslations'
import {apiUploadImage} from '@api/core/image/uploadImage'
import {apiEditThumbnail} from '@api/user/account/editThumbnail'
import useSnackbar from '@hook/useSnackbar'

interface IProps {
    className?: string
    downViewAlign?: 'start' | 'left' | 'center' | 'right' | 'end'
    onCustomChangeImage?: () => void
}

const WizThumbnailChangeInput: React.FC<IProps> = ({className, downViewAlign = 'center', onCustomChangeImage}) => {
    const t = useTranslation()
    const {showSnackbar, showErrorSnackbar} = useSnackbar()

    const {refetch: refreshMe} = useQueryFetchMe(undefined, false)

    const resetDefaultImage = useCallback(async () => {
        const {data, error} = await apiEditThumbnail('')
        if (data) {
            showSnackbar(t('mobileAccountNavigation.thumbnail.changeImage.success'))
            await refreshMe()
        } else {
            showErrorSnackbar(error)
        }
    }, [showSnackbar, showErrorSnackbar, refreshMe, t])

    const imageMenuOptionList = useMemo(
        () => [
            {title: t('mobileAccountNavigation.thumbnail.menu.pickImage'), onClick: onCustomChangeImage},
            {title: t('mobileAccountNavigation.thumbnail.menu.setDefault'), onClick: resetDefaultImage},
        ],
        [t, resetDefaultImage],
    )

    return (
        <WizDropdown
            containerClassName={'rounded-full'}
            downViewAlign={downViewAlign}
            optionList={imageMenuOptionList}
            renderView={
                <div className="absolute z-10 right-0 bottom-0">
                    <WizIcon
                        className={
                            ' bg-white dark:bg-bg_dark_background ring-[1px] ring-gray07 dark:ring-dark_gray07 p-[2px] hover:bg-gray06 dark:hover:bg-dark_gray06'
                        }>
                        <IconEdit className={'w-[12px] fill-gray02 dark:fill-dark_gray02'} />
                    </WizIcon>
                </div>
            }
        />
    )
}

export default WizThumbnailChangeInput
